import { postRequest } from '../../../utils';

const getErrorMessage = (errors: unknown, fallback: string): string => {
  if (Array.isArray(errors)) {
    const first = errors[0] as { message?: string } | undefined;
    if (first?.message) {
      return first.message;
    }
  }

  if (typeof errors === 'string' && errors) {
    return errors;
  }

  return fallback;
};

export type NotificationMarkAllResponse = {
  success: boolean;
  updatedCount?: number;
  error?: string;
};

export const markAllNotificationsAsRead = async (
  userId: number,
): Promise<NotificationMarkAllResponse> => {
  if (!userId) {
    return {
      success: false,
      error: 'userId is required',
    };
  }

  try {
    const result = await postRequest('/api/notification/markAllAsRead', {
      userId,
    });

    if (result?.errors) {
      return {
        success: false,
        error: getErrorMessage(result.errors, 'Failed to mark all notifications as read'),
      };
    }

    return {
      success: true,
      updatedCount: Number(result?.updatedCount ?? 0),
    };
  } catch (err) {
    console.error('Mark All Notifications Error:', err);
    return {
      success: false,
      error: 'A network error occurred while marking all notifications as read',
    };
  }
};
